if( window.localStorage.getItem('products_loading') != 0  )
{
    var attempts = 0;
    $(".messageProductLoading").show();
    var interval = setInterval(function()
    {
        attempts++;
        if(window.localStorage.getItem('products_loading') == 0 || attempts == 8){
            clearInterval(interval);
            $(".messageProductLoading").hide();
            if(attempts == 8){
            window.localStorage.setItem('products_loading', 0);
            }
            location.reload();
        }
    }, 3000); 
}


$('[id^=item-quantity-]').change(function(event) {

    disableButtons();

    // Last section in ID is the cart item index
    var targetSplit = event.target.id.split("-");
    var itemIndex = targetSplit[targetSplit.length - 1];
    var value = $(this).val();

    CartJS.updateItem(+itemIndex + 1, value, {}, {
        "success": function(data, textStatus, jqXHR){
            reloadPage();
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error updating the cart item");
        }
    });
});

$('[id^=item-add-]').click(function(event) {

    disableButtons();

    // Last section in ID is the cart item index
    var targetSplit = event.currentTarget.id.split("-");
    var itemIndex = targetSplit[targetSplit.length - 1];
    var value = $(`#item-quantity-${itemIndex}`).val();

    CartJS.updateItem(+itemIndex + 1, +value + 1, {}, {
        "success": function(data, textStatus, jqXHR){
            if(quantityWasUpdated(itemIndex, data, value, event.currentTarget.id))
            {
                reloadPage();
            }
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error updating the cart item");
        }
    });
});

$('[id^=item-substract-]').click(function(event) {

    disableButtons();

    // Last section in ID is the cart item index
    var targetSplit = event.currentTarget.id.split("-");
    var itemIndex = targetSplit[targetSplit.length - 1];
    var value = $(`#item-quantity-${itemIndex}`).val();

    CartJS.updateItem(+itemIndex + 1, +value - 1, {}, {
        "success": function(data, textStatus, jqXHR){
            if(quantityWasUpdated(itemIndex, data, value, event.currentTarget.id))
            {
                reloadPage();
            }
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error updating the cart item");
        }
    });
});

function disableButtons() {
    $('[id^=item-substract-]').prop('disabled', true);
    $('[id^=item-add-]').prop('disabled', true);
    $('[id^=item-quantity-]').prop('disabled', true);
}

function enableAllButtonsExceptCurrent(idToDisable) {
    $('[id^=item-substract-]').prop('disabled', false);
    $('[id^=item-add-]').prop('disabled', false);
    $('[id^=item-quantity-]').prop('disabled', false);
    $(`#${idToDisable}`).prop('disabled', true);
}

function reloadPage() {
    // Wait a second just to be sure the cart updated
    setTimeout(() => { location.reload(); }, 1000);
}

function quantityWasUpdated(index, cart, originalValue, buttonId) {
    if(cart.items[index].quantity === +originalValue){
        $(`[id^=stock-limit-message-${index}]`).show();
        enableAllButtonsExceptCurrent(buttonId);
        return false;
    }
    return true;
}